<template>
  <div class="partner-container">
    <main-nav :partnerScrollHeight="scrollHeight"/>
    <section class="main">
      <div class="banner" @click="getFocus('#container')">
        <div class="container"></div>
      </div>
      <div id="container" class="become-a-partner">
        <div class="container" style="max-width: 920px;">
          <h2>申请合作</h2>
          <a-row>
            <a-col :span="16" :offset="2">
              <a-form
                :form="partnerForm">
                <a-form-item label="合作业务" :allowClear="true" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-radio-group
                    v-decorator="['type',{ rules: [{ required: true, message: '请选择合作业务类型!' }] , initialValue: 2}]"
                    buttonStyle="solid" size="large">
                    <a-radio-button :value="2">我有视频版权</a-radio-button>
                    <a-radio-button :value="3">我需要内容授权</a-radio-button>
                    <a-radio-button :value="4">我想购买产品</a-radio-button>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="公司全称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input
                    ref="initFocus"
                    size="large"
                    placeholder="输入你的公司全称"
                    v-decorator="['name',{ rules: [{ required: true, message: '请输入公司全称!' }] }]"/>
                </a-form-item>
                <a-form-item label="联系方式" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input
                    v-decorator="['identity',{ rules: [{ required: true, message: '请输入手机号或邮箱!' }, {validator: identityVerify}], initialValue: account? account.identity : '' }]"
                    size="large"
                    placeholder="输入你的手机号或邮箱"
                  />
                </a-form-item>
                <a-form-item label="验证码" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-input
                    v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
                    size="large"
                    placeholder="输入验证码"
                  >
                    <a-button v-if="sendCodeCountDown == 0" slot="suffix" @click="sendVerifyCode"
                              :disabled="!partnerForm.getFieldValue('identity') || hasErrors(partnerForm.getFieldsError(['identity']))"
                              type="link">
                      获取验证码
                    </a-button>
                    <a-button v-if="sendCodeCountDown > 0" disabled slot="suffix">{{sendCodeCountDown}} 秒</a-button>
                  </a-input>
                </a-form-item>
                <a-form-item label="合作内容" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <a-textarea
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    v-decorator="['description',{ rules: [{ required: true, message: '请输入期望合作的业务信息!' }] }]"
                    size="large"
                    placeholder="期望合作的业务范围或自身业务现状"
                  />
                </a-form-item>
                <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 18 , offset: 6}">
                  <a-checkbox
                    v-decorator="[
              'agree',
              {
                valuePropName: 'checked',
                initialValue: true,
              },
            ]"
                  >
                    阅读并同意<a class="login-form-forgot" href="">《服务条款及隐私政策》</a>
                  </a-checkbox>
                  <a-alert
                    v-if="errorResp"
                    @close="clearErrorTimeout"
                    style="margin-bottom: 11px"
                    type="error"
                    :message="errorResp.message"
                    banner
                    closable
                  />
                  <a-button type="primary" :disabled="hasErrors(partnerForm.getFieldsError())" @click="submitApply"
                            html-type="submit" size="large" style="width: 100%">提交申请
                  </a-button>
                </a-form-item>
              </a-form>
            </a-col>
          </a-row>
        </div>
      </div>
    </section>
    <footer>
      <foot/>
    </footer>
  </div>
</template>

<script>
  import MainNav from '../components/MainNav'
  import Foot from '../components/Footer'
  import {mapState} from 'vuex'
  import ATextarea from "ant-design-vue/es/input/TextArea";

  export default {
    name: 'home-partner',
    components: {
      ATextarea,
      'main-nav': MainNav,
      'foot': Foot
    },
    computed: mapState({
      account: 'account'
    }),
    data: function () {
      return {
        partnerForm: this.$form.createForm(this),
        sendCodeCountDown: 0,
        verifyCode: false,
        errorResp: false,
        scrollHeight: false
      }
    },
    methods: {
      hasErrors(fieldsError) {
        return Object.keys(fieldsError).some(field => fieldsError[field])
      },
      identityVerify(rule, value, callback) {
        let error = false
        if (value) {
          if (!isNaN(value)) {
            if (!/^[1][34578]\d{9}$/.test(value) || !/^[1-9]\d*$/.test(value) || value.length !== 11) {
              error = '请输入正确的手机号'
            }
          } else if (value.indexOf('@') > 0) {
            if (!/^[A-Za-z0-9]+[A-Za-z0-9-_.]*@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
              error = '请输入正确的邮箱'
            }
          } else {
            error = '请输入手机号或邮箱'
          }
        } else {
          error = false
        }
        if (error) {
          callback(error)
        } else {
          callback()
        }
      },
      clearErrorTimeout() {
        this.errorResp = false
        if (this.errorTimeOut) {
          clearTimeout(this.errorTimeOut)
        }
      },
      submitApply(e) {
        e.preventDefault()
        const _this = this
        this.partnerForm.validateFieldsAndScroll((err, values) => {
          if (!err) {
            const _data = {...values}
            _data.identity_type = values.identity.indexOf('@') > 0 ? 2 : 1
            _data.code = {value: values.code, key: _this.verifyCode.key}
            _data.info = [{'value': _data.description, 'key': 'intro', 'name': '合作内容'}]
            delete _data.description
            _this.axios.post('/api/apply', _data).then(function (resp) {
              if (!_this.account && resp.token) {
                _this.$store.commit('setToken', resp.token)
                _this.$store.commit('setAccount', resp.account)
              }
              _this.partnerForm.resetFields()
              const _h = _this.$createElement;
              _this.$success({
                title: '提交成功',
                content: _h('div', {}, [
                  _h('p', '我们已收到您的合作申请，相关客服人员将尽快与您联系，请耐心等待。'),
                ])
              })
            }).catch(function (err) {
              _this.errorResp = err
              _this.errorTimeOut = setTimeout(function () {
                _this.clearErrorTimeout()
              }, 3000)
            })
          }
        })
      },
      codeCountDown() {
        this.sendCodeCountDown = this.sendCodeCountDown - 1
        if (this.sendCodeCountDown > 0) {
          const _this = this
          setTimeout(function () {
            _this.codeCountDown()
          }, 1000)
        }
      },
      sendVerifyCode() {
        const identity = this.partnerForm.getFieldValue('identity')
        const data = {type: 'partner', provider: 'Sms', identity: identity}
        if (identity.indexOf('@') > 0) {
          data.provider = 'Email'
        }
        this.sendCodeCountDown = 30
        const _this = this
        this.axios.post('/api/common/code', data).then(function (resp) {
          _this.verifyCode = resp
          _this.codeCountDown()
        }).catch(function () {
          _this.verifyCode = false
        })
      },
      getFocus(selector) {
        this.$nextTick(() => {
          this.$refs.initFocus.focus()
          this.$el.querySelector(selector).scrollIntoView({
            behavior: "smooth",
            block:    "start"
          })
        })
      },
      monitorScroll: function () {
        let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.scrollHeight = scrollHeight
      }
    },
    mounted() {
      window.addEventListener('scroll', this.monitorScroll)
      window.scroll(0,0)
      this.scrollHeight = 0
    },
    beforeDestroy() {
      document.removeEventListener('scroll', this.monitorScroll)
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/style/var";
  @import "../assets/style/common";

  .partner-container {
    section.main {
      div.banner {
        background: #f39502 url("../assets/img/official/partner-main-background.jpg") no-repeat center;
        background-size: auto 480px;
        height: 480px;
      }

      .become-a-partner {
        margin: 0 auto;
        padding: 70px 0;
        background: @white-color;

        h2 {
          background: url("../assets/img/official/partner-title.jpg") no-repeat left center;
          background-size: contain;
          height: 40px;
          text-indent: -999px;
          margin-bottom: 52px;
        }
      }
    }
  }
</style>
